// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import deputyreqEntity from './entities/deputyreq.json';
import deputyreqMenu from '../pages/deputyreq/menu.json';
import deputyreqFullForm from '../pages/deputyreq/forms/full.json';
import deputyreqContextForm from '../pages/deputyreq/forms/context.json';
import deputyreqMiniForm from '../pages/deputyreq/forms/mini.json';
import deputyreqLookupForm from '../pages/deputyreq/forms/lookup.json';
import deputyreqTableView from '../pages/deputyreq/views/table.json';
import deputyreqStagesView from '../pages/deputyreq/views/stages.json';
import deputyreqCardsView from '../pages/deputyreq/views/cards.json';
import deputyreqInlineView from '../pages/deputyreq/views/inline.json';
import deputyreqBacklogView from '../pages/deputyreq/views/backlog.json';
import deputyreqSplitView from '../pages/deputyreq/views/split.json';
import deputyreqCalendarView from '../pages/deputyreq/views/calendar.json';
import deputyreqDashboardView from '../pages/deputyreq/views/dashboard.json';

/** Тип запису «Запит» зі сторінками пакета: меню, форми та подання з pages/deputyreq/. */
export const deputyreqDefinition: IRecordTypeDefinition = {
  ...deputyreqEntity,
  views: assembleViewSet({
      table: deputyreqTableView,
      stages: deputyreqStagesView,
      cards: deputyreqCardsView,
      inline: deputyreqInlineView,
      backlog: deputyreqBacklogView,
      split: deputyreqSplitView,
      calendar: deputyreqCalendarView,
      dashboard: deputyreqDashboardView,
  }),
  form: deputyreqFullForm,
  forms: { full: deputyreqFullForm, context: deputyreqContextForm, mini: deputyreqMiniForm, lookup: deputyreqLookupForm },
  menu: deputyreqMenu,
} as IRecordTypeDefinition;
